module.exports = __webpack_public_path__ + "img/pricing.65dbaeb8.svg";